export const baseApiURL = process.env.NEXT_PUBLIC_BASE_API_URL

export const apiEndPoints = Object.freeze({
  getAllVenueListNew: 'venue/by-multiple-type',
  departmentListNew: 'department',
  program: 'programs',
  allProgram: 'programs/all',
  allProgramOptmized: 'programs/all-optimized',
  Rmat: 'rmat',
  orientationScheduleStudentList: 'orientataion-schedule/student',
  orientationScheduleLogList: 'orientataion-schedule/email-logs',
  debitenrolment: 'enrolment/verify-debitorder',
  duplicateRmat: 'rmat/check-duplicate-rmat',
  statusHistory: 'application/status-history',
  groups: 'groups',
  intake: 'intake',
  duplicateIntake: 'intake/check-duplicate-intake',
  courses: 'courses',
  coursesByProgram: 'courses/program',
  coursesByProgramCode: 'courses/program/{programCode}',
  year: 'common/year',
  schedule: 'schedule',
  checkDuplicateIdNumber: 'lead/check-duplicate-id-number/:idNumber/leadId/:leadId',
  scheduleTask: 'schedule-task',
  studentintake: 'studentintake',
  intakeStudent: 'intake/students',
  student: 'student',
  nqfLevel: 'common/NQF-level',
  categories: 'common/category',
  studymode: 'common/study-mode',
  intakeStudentList: 'sales/student',
  refreshToken: 'auth/refresh-token',
  studentRecord: '/application/student/Record/all',
  studentAllRecord: 'academic/records',
  studentRecords: '/application/student/Record/all',
  aggreegatStudents: 'student/aggregate/',
  agentDetailsByCode: 'user/code',
  fileUpload: 'common/document/upload',
  programsCode: 'programs/code',
  programCourses: 'courses/program/',
  exemptCourse: 'academic/update/exemptedCourse/status',
  country: 'common/country',
  getDocument: 'common/document?filename=',
  activeGroup: 'groups/active',
  addressList: 'common/address-type',
  allIntake: 'intake/all',
  allSemester: 'semester',
  duplicateGroup: 'groups/check-duplicate-group',
  duplicateProgram: 'programs/check-duplicate-program',
  duplicateCourse: 'courses/check-duplicate-course',
  userDetails: 'user',
  duplicateProgramName: 'programs/check-duplicate-program-name',
  subProgram: 'sub-program',
  duplicateSubProgram: 'sub-program/check-duplicate-sub-program',
  roles: 'roles',
  requestAccess: 'user/request-access',
  courseAcademicReport: 'academic/academic-report/course',
  graduation: 'graduation',
  classroom: 'venue/by-type',
  GroupFilterList: 'groups/filter/optionList/all',
  gender: 'common/gender',
  nationality: 'common/nationality',
  language: 'common/language',
  stateByCountry: 'common/state',
  race: 'common/race',
  nationalityStatus: 'common/nationality-status',
  identificationType: 'common/identification-Type',
  qualification: 'common/qualification',
  coursedetails: 'class-management/courses',
  programfee: 'programs-fee/byProgramCode',
  scedule: 'class-management/details',
  test: 'attendance',
  class: 'class-management',
  attendance: 'attendance/attendance',
  throughputReport: 'through-put/report',
  attendanceUpdate: 'attendance',
  facilitator: 'facilitator',
  updatestudent: 'admitted-students',
  updateaddress: 'sales/:appCode/update/address',
  attedenceCourses: 'attendance/courses',
  venu: 'venue',
  allVipStudent: 'sales/allVip/student',
  studyModeList: 'common/study-mode',
  query: 'query',
  orientationSchedule: 'orientataion-schedule',
  orientationScheduleSingleResend: 'orientataion-schedule/resend-single-agenda',
  ugPgData: 'orientataion-schedule',
  resendAllEmail: 'orientataion-schedule/send-agenda',
  resendBulkAgenda: 'orientataion-schedule/resend-bulk-agenda',
  fileUploadMaster: 'common/master/document/upload',
  throughput: 'operation/aggregate',
  risk: 'risk',
  agents: 'user/role',
  venueType: 'common/venue-status',
  queryType: 'common/query-type',
  students: 'application/students',
  searchStudent: 'application/search-student/',
  unenrolledStudents: 'application/unenrolled-record',
  getAuditLog: 'common/get-audit-log',
  checkDuplicateEmail: 'admitted-students/check-duplicate-email',
  relationShipData: 'common/relationship',
  updateKin: 'update/kin',
  updateSponsor: 'update/sponsor',
  loadMasterData: 'master/loadMasterData ',
  studentStatus: 'common/student-status',
  progressReport: 'academic/progress-report',
  admittedStudent: 'admitted-students',
  getStudentDetail: '/application/student-details/:studentCode',
  throughPut: 'through-put',
  department: 'department',
  documentTypeList: 'common/all-document-type',
  uploadFileUrl: 'common/document/upload',
  enrolmentList: 'sales',
  reUploadDocument: 'operation/update-document',
  academicRecord: 'academic/academic-record',
  reggieCheckDuplicateMobile: 'reggieNumber/reggie-data-duplicate-mobile',
  getActivityTimeline: 'application/activity-timeline/audit-log',
  documentFileType: 'document/',
  updateDocumentStatus: 'document/:documentCode/active',
  documentRemove: 'document/documentCode',
  document: 'document',
  documentCode: 'common/next-code/DOC',
  vipStudent: 'sales/updateVIPComment',
  sendPaymentLink: 'sales/sendPaymentLink',
  updateBursary: 'update/bursaryName',
  updatecourse: 'sales/:appCode/update/course',
  studentList: 'application',
  enrollStudent: 'admissions/accept/',
  approveEnrolment: 'sales/accept/',
  admission: 'admissions/',
  corporateStudentApprove: 'corporate-student/approve/application',
  corporateStudentApproveDocument: 'corporate-student/approve/document',
  corporateStudentFilterList: 'corporate-student/filter/optionList',
  projectList: 'project',
  projectDocumentDelete: 'project/projectCode/document',
  isRmatRequired: 'rmat/programCode',
  checkDuplicateProject: 'project/check-duplicate-project',
  enrollProjectStudent: 'projectStudent/status',
  rmatLink: 'rmat/send-rmat-link',
  rmat: 'rmat/',
  rmatDetails: 'rmat/details',
  rmatExamDetails: 'rmat/exam-details',
  projectStudentDocument: 'projectStudent',
  unenrollStudent: 'admitted-students/unenroll-student',
  assignStudentType: 'application/assign-student-type',
  ssaList: 'ssa/list',
  assignSSA: 'ssa/assign-ssa',
  downloadAcademicTranscript: 'academic/donwload/academic-records',
  downloadAcademicTranscriptReport: 'academic/donwload/transcript',
  downloadAcademicTranscripts: 'academic/donwload/academic-records/student/:studentCode/program/:programCode/all',
  checkAndUpdateStatus: 'sales/:applicationCode/update-status',
  exportStudent: 'application/export/search-student',
  intakeLists: 'intake',
  toExcel: 'graduation/to-excel',
  excel: 'graduation/excel',
  admittedStudents: 'admitted-students/all',
  orientationScheduleIntake: 'orientataion-schedule/intake/upcoming',
  electiveModuleMonitoring: 'elective-monitoring/dashboard',
  cancelElectiveModule: 'elective-monitoring/unenroll',
  studentDetailsProgressReport: '/application/student-complete-details',
  downloadProgressReport: 'academic/donwload/progress-report',
  enableProgressReport: 'academic/enable-progress-report',
  progressReportLogs: 'academic/progress-report-activity-logs',
  progressReportRequest: 'academic/progress-report/request',
  menuConfig: 'common/menu-config'
})
